export { KTThemeSwitch } from './theme-switch';
export type { KTThemeSwitchConfigInterface, KTThemeSwitchInterface } from './types';
